// extracted by mini-css-extract-plugin
module.exports = {"ctaPanel":"cta-panel-module--cta-panel--wwdE8","ctaPanel__container":"cta-panel-module--cta-panel__container--TR3oV"};